/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Body, POST, RebirthHttp } from 'rebirth-http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LogoutRequest } from '../interfaces/logout.interface';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { HttpErrorHandlerService } from 'src/app/shared-resources/services/http-error-handling.service';
import {
  UserResponse,
  UserTokenResponse,
} from 'src/app/shared-resources/interfaces/base-core-services.interface';
import { CookieService } from 'ngx-cookie-service';
import { ClearClm } from '@shared-store/clm.action';
import { Store } from '@ngxs/store';
import { ClmState } from '@shared-store/clm.state';
import { UserInfo } from '@shared-store/base.action';

@Injectable()
export class LogoutService extends RebirthHttp {
  public isLogout = false;
  public logoutBody: any;
  public logoutModalRef: NzModalRef;
  public isLogoutModalOpen = false;
  constructor(
    http: HttpClient,
    // public cookieService: CookieService,
    private router: Router,
    public userInfo: UserInfoService,
    public httpMessage: HttpErrorHandlerService,
    private modalService: NzModalService,
    private translateService: TranslateService,
    private cookieService :CookieService,
    private store:Store
  ) {
    super(http);
    this.userInfo.getUserLogout$().subscribe((res) => {
      if (res === 'sessiontimeout') {
        sessionStorage.clear();
        if (!this.isLogoutModalOpen)
          this.showLogoutModal(
            this.translateService.instant('app.label.session-timeout'),
            this.translateService.instant(
              'app.label.session-expired.login-again'
            )
          );
      } else if (res === 'windowclose') {
        if (this.isLogout) this.clearUserSession();
      } else if (res === 'resetpassword') {
        const formBody = {
          token: this.userInfo.getUserToken(),
          userName: this.userInfo.getUserName(),
        };
        if (!this.isLogoutModalOpen)
          this.showLogoutModal(
            this.translateService.instant('app.login.resetpassword'),
            this.translateService.instant(
              'app.label.login.after-password-reset'
            ),
            formBody
          );
      }
    });
  }

  // Remove the @POST decorator and implement logout manually
  logout(logoutRequest: LogoutRequest): Observable<UserTokenResponse> | null {
    const logoutUrl = `${environment.baseUrl}${environment.wso2amEndPoint}${environment.identityServerName}${environment.wso2amApiVersion}/api/v1/auth/logout`;
    return this.http.post<UserTokenResponse>(logoutUrl, logoutRequest);
  }

  clearUserSession(): void {
    this.store.dispatch(new ClearClm());
    this.userInfo.setUserInfo({ photoPath: null });
    this.clearData();
  }

  clearData(): void {
    // Signal other tabs to logout
    localStorage.setItem('logout-event', Date.now().toString());

    if (this.logoutBody) {      
      this.logout(this.logoutBody)?.subscribe(
        (): void => {
          this.logoutBody = null;
        });
    }
    if (this.logoutModalRef) {
      this.logoutModalRef.close();
    }
    this.isLogout = false;
    this.router.navigateByUrl('/login');
    this.cookieService.deleteAll(
      window.location.pathname,
      window.location.hostname
    );
    this.cookieService.deleteAll();
    localStorage.clear();
    sessionStorage.clear();
  }

  showLogoutModal(title: string, content: any, logoutBody?: any): void {
    this.isLogoutModalOpen = true;
    let userInfo: UserResponse | undefined = this.userInfo.getUserInfo();
    if (userInfo) {
      userInfo.token = '';
    } else if (userInfo === undefined) {
      userInfo = { photoPath: null };
    }
   // this.userInfo.setUserInfo(userInfo);
    this.isLogout = true;
    this.logoutBody = logoutBody;
    this.logoutModalRef = this.modalService.create({
      nzTitle: title,
      nzContent: content,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'logoutmodal',
      nzFooter: [
        {
          label: 'Ok',
          size: 'default',
          onClick: () => {
            this.clearUserSession();
            this.isLogoutModalOpen = false;
          },
        },
      ],
    });
  }
}
